module.exports = __webpack_public_path__ + "img/home1.69cea4a1.svg";